import FreeSpinsIssued from '../../components/FreeSpins/Issued/Issued';
import { ActionType } from '../../enums';

import {
  TXTCLI_CongratulationsX_you_have_Free_ELL,
  TXTCLI_OK
} from './FreeSpins.Issued.messages.json';

export default {
  front: {
    view: FreeSpinsIssued,
    viewConfig: {
      title: { tag: TXTCLI_CongratulationsX_you_have_Free_ELL },
      actions: [
        {
          actionType: ActionType.Primary,
          actionLabel: { tag: TXTCLI_OK }
        }
      ]
    }
  }
};
